import { useRouter } from "components/hooks";
import { toast } from "react-toastify";
import { useQuery } from "@tanstack/react-query";
import { get } from "utils/request";
import { getPollEndpoint } from "apis/poll";
// import moment from "moment";
import { ROUTES, TOAST_CONFIG } from "../../constants";
import Loading from "../../components/atoms/Loading";
import Poll from "./Poll";

const defaultPollFormValues = {
  questions: [
    { question: "", choices: [{ text: "" }, { text: "" }] },
    { question: "", choices: [{ text: "" }, { text: "" }] },
  ],
};

function PollPage({ isEditForm }: { isEditForm?: boolean }) {
  const router = useRouter();
  const { pollId, magnetId } = router.query;

  const handleGetPollDetailsFailure = (errorMessage: string, error: any) => {
    toast.error(errorMessage, TOAST_CONFIG);
    if (error.response.status === 404) {
      router.go(`/${ROUTES.NOT_FOUND}`);
      return;
    }
    throw new Error(errorMessage);
  };

  const getPollData = () =>
    isEditForm && pollId
      ? get(getPollEndpoint(magnetId, pollId), {
          processError: handleGetPollDetailsFailure,
        })
      : null;

  const {
    isLoading: isPollDetailsLoading,
    error: pollDetailsError,
    data: pollDetails,
  } = useQuery({
    queryKey: [magnetId, pollId],
    queryFn: getPollData,
  });

  if (isPollDetailsLoading) return <Loading />;
  if (pollDetailsError) return <p>Something went wrong!</p>;

  const pollData = isEditForm
    ? {
        name: pollDetails.name,
        questions: pollDetails.question.map((questionText: string, qId: number) => ({
          question: questionText,
          choices: pollDetails.choices[qId].map((choiceObj: any) => ({ text: choiceObj.name })),
        })),
        end_time: null,
        viewer_type: pollDetails.viewer_type,
      }
    : defaultPollFormValues;

  return (
    // @ts-ignore
    <Poll pollDefaultValues={pollData} isPublished={!!(isEditForm && pollDetails.status)} isEditForm={!!isEditForm} />
  );
}

export default PollPage;
